<script setup lang="ts">
import type { ConfiguratorPoolLine } from '~/models/configurator/configuratorPoolLine.model'

interface Props {
  poolLines: ConfiguratorPoolLine[]
  currentPoolLine: ConfiguratorPoolLine | null
}
const props = defineProps<Props>()

const emits = defineEmits<{
  selectPoolLine: [ConfiguratorPoolLine]
}>()

const { dt } = useDirectusTranslation()

function selectPoolLine(poolLine: ConfiguratorPoolLine) {
  emits('selectPoolLine', poolLine)
}

function poolLineIsActive(poolLine: ConfiguratorPoolLine) {
  return poolLine.id === props.currentPoolLine?.id
}

const selectedPoolLine = computed<ConfiguratorPoolLine | null>({
  get: () => props.currentPoolLine,
  set: (value) => {
    if (value)
      selectPoolLine(value)
  },
})

function onSelectPoolLine(poolLine: ConfiguratorPoolLine) {
  selectedPoolLine.value = poolLine
}
</script>

<template>
  <div class="mx-auto flex-none items-center gap-4 px-8 py-2 container">
    <div class="w-full flex flex-col items-center gap-2 lg:w-auto">
      <p class="h-6 text-1.3rem">
        {{ dt(currentPoolLine?.translations)?.name }}
      </p>
      <div class="my-4 w-full flex flex-col gap-2 text-center text-lg opacity-60">
        <p v-for="usp in dt(currentPoolLine?.translations)?.usps" :key="usp">
          {{ usp }}
        </p>
      </div>

      <div
        class="grid grid-cols-2 w-full gap-2"
      >
        <AppButton
          v-for="line in poolLines"
          :key="line.id"
          size="full"
          :is-active="poolLineIsActive(line)"
          @click="onSelectPoolLine(line)"
        >
          {{ dt(line?.translations)?.name }}
        </AppButton>
      </div>
    </div>
  </div>
</template>
